import type { FC, ReactNode } from 'react';
import React from 'react';

import type { TBrandBar, IBadge } from './models';

export const BrandBar: FC<TBrandBar> = ({ Img, badgeImgDirectory, badges, onClick, styles }) => {
    const items: ReactNode[] = badges.reduce(
        (result: ReactNode[], { badgeImg, label, value }: IBadge) => {
            if (badgeImg === undefined) {
                return result;
            }

            const button = (
                <button
                    key={value}
                    className={styles.badge}
                    onClick={() => onClick(value)}
                    title={label}
                >
                    <Img alt={`Логотип ${label}`} src={`${badgeImgDirectory}${badgeImg}`} />
                </button>
            );

            return [...result, button];
        },
        []
    );

    if (items.length === 0) {
        return null;
    }

    return <section className={styles.brandBar}>{items}</section>;
};
